import '../wwwroot/js/shared-operation-controls.js';
import '../wwwroot/css/shared-operation-controls.css';

export type LoadingOptions = { title?: string; message?: string; immediate?: boolean };
export type OperationOptions = { skipLink?(link: HTMLAnchorElement): boolean; copy?(kind: 'navigation' | 'submit' | 'partial'): LoadingOptions };
declare global {
  interface Window {
    profintLoading?: { show(options?: LoadingOptions): void; hide(): void; hideAll?(): void };
  }
}
export function initOperations(options: OperationOptions = {}): void {
  const apply = () => (window as unknown as { ProfintOperations: { init(root: Document, options: OperationOptions): void } }).ProfintOperations.init(document, options);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
  else apply();
}
